import { Recipe } from '@api/Recipes/Recipe';
import RecipeServ from '@api/Recipes/RecipeServ';

class RecipesService {
    saveRecipe = (recipe: Recipe): Promise<Recipe> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await RecipeServ.saveRecipe(recipe);
                resolve(data);
            } catch (error) {
                reject('Error saving recipe: ' + error);
            }
        });
    };
    getRecipes = (): Promise<Recipe[]> => {
        return new Promise(async (resolve, reject) => {
            try {
                const data = await RecipeServ.getRecipes();
                resolve(data);
            } catch (error) {
                reject('Error getting recipes: ' + error);
            }
        });
    };
    getRecipe = (recipeId: string): Promise<Recipe> => {
        return new Promise(async (resolve, reject) => {
            try {
                const recipe = await RecipeServ.getRecipe(recipeId);
                resolve(recipe);
            } catch (error) {
                reject('Error getting recipe: ' + error);
            }
        });
    };
    deleteRecipe = (recipeId: string): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                await RecipeServ.deleteRecipe(recipeId);
                resolve();
            } catch (error) {
                reject('Error deleting recipe: ' + error);
            }
        });
    };
}
export default RecipesService;
